import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
padding: 20px;
border-radius: 100%;
border: none;
background-color: var(--socialtext);
padding: 10px;
font-weight: bold;
color: var(--secondary-text);
width: 200px;
cursor: pointer;
align-items: center;
justify-content: center;
box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
:active {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
`;
export const StyledWButton = styled.button`
padding: 20px;
border-radius: 100%;
border: none;
background-color: var(--bar);
padding: 10px;
font-weight: bold;
color: var(--secondary-text);
width: 130px;
cursor: pointer;
align-items: center;
justify-content: center;
box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
:active {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
`;
export const StyledW2Button = styled.button`
padding: 20px;
border-radius: 100%;
border: none;
background-color: var(--bar);
padding: 10px;
font-weight: bold;
color: var(--secondary-text);
width: 80px;
cursor: pointer;
align-items: center;
justify-content: center;
box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
-moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
:active {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
`;
export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary-text);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--textlogo);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 300px;
  @media (min-width: 300px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;
export const StyledOLogo = styled.img`
  width: 170px;
  @media (min-width: 170px) {
    width: 170px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;
export const StyledALogo = styled.img`
  width: 100px;
  @media (min-width: 100px) {
    width: 100px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;
export const StyledSocials = styled.img`
  width: 30px;
  @media (min-width: 30px) {
    width: 30px;
  }
  transition: width 1s;
  transition: height 1s;
`;
export const StyledOSocials = styled.img`
  width: 100px;
  @media (min-width: 100px) {
    width: 100px;
  }
  transition: width 1s;
  transition: height 1s;
`;
export const Styledlogo2 = styled.img`
  width: 120px;
  @media (min-width: 120px) {
    width: 120px;
  }
  transition: width 1s;
  transition: height 1s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.7);
  border: 0px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 10%;
  width: 400px;
  @media (min-width: 400px) {
    width: 400px;
  }
  @media (min-width: 400px) {
    width: 400px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`🐶ADOPTION READY🐶`);
  const [feedback1, setFeedback1] = useState(`🎫OG MINT SOON! | 6 Matic🎫`);
  const [feedback2, setFeedback2] = useState(`💎WL MINT SOON! | 8 Matic💎`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`📝SIGNING PAPERS📝`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the adoption of ${CONFIG.NFT_NAME} is successful! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 30) {
      newMintAmount = 30;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 0, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/webbanner.png" : null}
      >                                 
         <a>
          <StyledALogo    onClick={(e) => {
            window.open("https://crypticaspinsclub.netlify.app");
          }} style={{marginBottom:20, marginTop:30}}alt={"logo"} src={"/config/images/logo5.png"} /> 
                               <StyledLogo onClick={(e) => {
                  window.open("/config/AboutUS.pdf");}} 
                  style={{marginLeft:10, marginTop:30, marginBottom:20}}alt={"logo"} 
                  src={"/config/images/logo2.png"} />
           </a> 
        <s.SpacerSmall />
        <ResponsiveWrapper flex={1} style={{ padding: 0, borderRadius: 24,}} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
  
            <StyledImg alt={"example"} src={"/config/images/gif2.gif"} />

          </s.Container>
          <s.SpacerLarge />
          <s.Container
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "var(--accent)",
              margin:0,
              padding: 0,
              borderRadius: 24,
              border: "0px dashed var(--secondary)",
              boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.7)",
            }}
          >                    
             <s.TextAPower
          onClick={(e) => {
            window.open("/config/Guidebook.pdf");
          }}
            style={{
              marginTop:50,
              marginRight: 0,
              marginBottom:45,
              textAlign: "center",
              color: "var( --primary-text)",
            }}
          >
           📕GUIDEBOOK      
          </s.TextAPower>   
            <s.TextDescription
              style={{
                marginBottom:10,
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                color: "var(--socialtext)",
              }}
            >
              {data.totalSupply} | {CONFIG.MAX_SUPPLY}
            </s.TextDescription>
            <s.TextTitle
                  style={{marginTop:10, textAlign: "center", color: "var(--primary-text)" }}
                >
            🎉PUBLIC SALE! | {CONFIG.DISPLAY_COST} {CONFIG.NETWORK.SYMBOL}🎉{" "}
                 
                </s.TextTitle>


            <s.SpacerSmall />
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                
                <StyledButton  target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                <s.TextDescription
                      style={{
                        
                        textAlign: "center",
                        color: "var(--secondary-text)",
                      }}
                    >  
                  {CONFIG.MARKETPLACE}</s.TextDescription>
                </StyledButton>
                
              </>
            ) : (
              <>


                <s.SpacerXSmall />

                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>

                    <s.SpacerSmall />
                    <StyledButton
                       onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}

                                    style={{
                                      margin: "0px",
                                      padding: 10,
                                      borderRadius: 100,
                                      boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.7)",
                                    }}
                                  

                    >
                       <s.TextDescription
                      style={{
                        letterSpacing:0,
                      wordSpacing:2,
                        textAlign: "center",
                        color: "var(--textlogo)",
                      }}
                    >
                      CONNECT
                      </s.TextDescription>
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>

                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ 
                          borderRadius: 5,
                                      boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.7)",
                          lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--primary-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                          style={{ 
                                 borderRadius: 5,
                                 boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.7)",
                                 lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                           style={{ 
                             borderRadius: 100,
                               boxShadow: "0px 0px 0px 0px rgba(0,0,0,0.7)",
                                 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                       <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--textlogo)",
                      }}
                    >
                        {claimingNft ? "!ARF" : "MINT"}
                        </s.TextDescription> 
                      </StyledButton>
                    </s.Container>
                    <s.TextDescription
                      style={{
                        marginTop:20,
                        textAlign: "center",
                        color: "var(--primary-text)",
                      }}
                    >
                      {feedback}
                      <s.TextDescription
                      style={{
                        marginTop:40,
                        textAlign: "center",
                        color: "var(--socialtext)",
                      }}
                    >
                      {feedback1}
                      <s.TextDescription
                      style={{
                        marginTop:20,
                        textAlign: "center",
                        color: "var(--socialtext)",
                      }}
                    >
                      {feedback2}
                    </s.TextDescription>
                    </s.TextDescription>
                    </s.TextDescription>
            <s.TextGFPower
        

        style={{
          marginTop:40,
          marginRight: 0,
          marginBottom:0,
          textAlign: "center",
          color: "var(--primary-text)",
        }}
      >
       FAST TRANSACTION STEPS.
      </s.TextGFPower>
              <s.TextGPower
        

            style={{
              marginTop:15,
              marginRight: 0,
              marginBottom:0,
              textAlign: "center",
              color: "var(--bar)",
            }}
          >
           Edit Estimated Gas Fee.
          </s.TextGPower>
          <s.TextGPower
        

        style={{
          marginTop:15,
          marginRight: 0,
          marginBottom:0,
          textAlign: "center",
          color: "var(--bar)",
        }}
      >
       Change Max Priority & Max Fee.
      </s.TextGPower>
      <s.TextGPower
        

        style={{
          marginTop:15,
          marginRight: 0,
          marginBottom:0,
          textAlign: "center",
          color: "var(--bar)",
        }}
      >
       Type (60-80) GWEI.
      </s.TextGPower>
                  </>
                )}
              </>
            )}

            <s.SpacerMedium />
          </s.Container>
          </ResponsiveWrapper>
          <s.SpacerLarge />
        <s.SpacerMedium />
        <s.TextAPower
          onClick={(e) => {
            window.open("/config/AboutUS.pdf");
          }}
            style={{
              marginTop:20,
              marginRight: 0,
              marginBottom:20,
              textAlign: "center",
              color: "var( --textlogo)",
            }}
          >
           📜ABOUT US      
          </s.TextAPower>

        <a  onClick={(e) => {  window.open("https://www.facebook.com/crypticaspins/"); }}>
          <StyledSocials 
           style={{marginTop:0, marginBottom:10, marginRight:25}} alt={"Facebook"} src={"/config/images/facebook.png"} />
              <a  onClick={(e) => {  window.open("https://twitter.com/crypticaspins"); }}>
          <StyledSocials 
           style={{marginTop:0, marginBottom:10, marginRight:25}} alt={"Twitter"} src={"/config/images/twitter2.png"} />
           <a onClick={(e) => {  window.open("https://discord.gg/VUxKu28NJF"); }}>
          <StyledSocials style={{marginTop:0, marginBottom:10, marginRight:5}} alt={"Discord"} src={"/config/images/discord1.png"} />
          <a onClick={(e) => {  window.open("https://opensea.io/collection/crypticaspinsclub"); }}>
          <StyledOSocials style={{marginTop:0, marginBottom:15, marginLeft:10}} alt={"Opensea"} src={"/config/images/opensea3.png"} />
          </a></a></a></a>


          <s.TextPower
           onClick={(e) => {
            window.open("https://polygonscan.com/token/0x03a350637b22d46e00aacb0edd8e70ab76862a12");
          }}
            style={{
              marginTop:10,
              marginRight: 0,
              marginBottom:30,
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
           POWERED BY POLYGON🔗
          </s.TextPower>

</s.Container>

       
    </s.Screen>
  );
}

export default App;
